export enum EventsType {
    NOTIFICATION_READ = 'lux:notification:read',
    WINDOW_TOAST = 'lux:window:toast'
}